export default __webpack_public_path__ + "static/media/exterior design2.1e8c7cc8.jpg";